import {
    Button,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@mui/material";
import axios from "../../../utils/axiosInstance";
import { enqueueSnackbar, useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { PAGE_TEMPLATE } from "../LandingPage/constants";
import { MILLIS_TO_LOCALE } from "../../../utilities/helpers/formatUnix";
import ChangeLogTable from "./ChangeLogTable";

const ChangeLog = () => {
    return (
        <div className="config-heading">
            {/* List of all change logs */}
            <ChangeLogTable />
        </div>
    );
};

export default ChangeLog;
